export class DirectlyDownloadFileOnProductPage {
  private files;

  constructor() {
    if (document.querySelectorAll('.js-download-file').length > 0) {
      this.files = document.querySelectorAll('.js-download-file');
      sessionStorage.removeItem('mediaSource__clicked');
      this.listeners();
    }

  }

  listeners() {
   this.files.forEach(file => {
     file.addEventListener('click', e => {
       sessionStorage.setItem('mediaSource__clicked', e.currentTarget.dataset.mediaSource);
     });
   });
  }

  static downloadFile()  {
    const mediaId = sessionStorage.getItem('mediaSource__clicked');
    if (mediaId) {
      const a = document.querySelector('[data-media-source="' + mediaId + '"]') as HTMLLinkElement;
      if (a) {
        a.click();
        sessionStorage.removeItem('mediaSource__clicked');
      }
    }
  }
}
